module.exports = __webpack_public_path__ + "img/relevance.2c05af90.svg";